import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import { useContext, useEffect, useState } from 'react';
import { Storage } from 'aws-amplify';

//material-ui
import RefreshIcon from '@material-ui/icons/Refresh';
import PrintIcon from '@material-ui/icons/Print';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Loading } from '../common/variables';
import { AppContext } from '../context/app';

export function AthleteDetails(){
    const { appState : { athleteInView : athlete}} = useContext(AppContext);
    const [loading , setLoading] = useState(true);
    const [s3url , setS3Url ] = useState("");
    useEffect(()=>{
        setTimeout(()=>setLoading(false) ,500);
        if(athlete){
          getS3PhotoUrl(athlete.gender , athlete.photo_url);
        }
    },[]);
      async function getS3PhotoUrl(gender="male",key=""){
        if(!key.trim()){
          if(!gender){
            setS3Url("");
          }
          key = `${gender.toLowerCase()}_photo`;
        }
        try{
          const url =  await Storage.get(key);
          setS3Url(url);
        }
        catch(err){
          console.log({err});
          setS3Url("");
        }
      }
    return(
      <div className="mr-2 p-2">
        <div className="d-flex mb-1 justify-content-between">
            <h4>Athletes Details</h4>
            <div className="d-flex align-items-center">
                <Button size="sm" variant="outline-dark" className="ml-2"><PrintIcon/></Button>
                <Button size="sm" variant="outline-dark" className="ml-2"><PictureAsPdfIcon/></Button>
                <Button size="sm" variant="outline-success" className="ml-2"><RefreshIcon/></Button>
            </div>
        </div>
        {
          loading ? <Loading/> :
          <>
          <Form style={{ paddingTop : 10}}>
            <Form.Row style={{display : "flex" , justifyContent : "flex-end"}}>
              <Image src={s3url} style={{ height : 150 , width : 150 }} />
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>AAB ID</Form.Label>
                  <Form.Control readOnly type="text" defaultValue={athlete.id}/>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control readOnly type="text" defaultValue={athlete.email}/>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Alternate Email</Form.Label>
                  <Form.Control readOnly type="text" defaultValue={athlete.alt_email}/>
                </Form.Group>
              </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>First Name</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.first_name}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Middle Name</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.middle_name}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.last_name}/>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>National ID</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.nrid}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.dob}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Gender</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.gender}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Nationality</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.nationality}/>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Address</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.address}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Parish</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.parish}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Country</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.country}/>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>School</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.school.name}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Club</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.club.name}/>
              </Form.Group>
            </Form.Row>  <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Shoe Size</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.shoe_size}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Shirt Size</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.shirt_size}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Shirt Size</Form.Label>
                <Form.Control readOnly type="text" defaultValue={athlete.pants_size}/>
              </Form.Group>
            </Form.Row>
          </Form>

          </>
         }
    </div>)
  }